import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styles from "./EventSection.module.css";
import API_BASE_URL from "../../config/api";

const EventSection = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("ongoing");

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/fetchEvents.php`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const text = await response.text();
        let data;
        try {
          data = JSON.parse(text);
          console.log("5. Parsed data:", data);
        } catch (e) {
          console.error("6. JSON parse error:", e);
          throw new Error("Invalid JSON response");
        }
        
        if (Array.isArray(data)) {
          console.log("7. Data is array, length:", data.length);
          setEvents(data);
        } else {
          console.log("7. Data is not array:", data);
          setEvents([]);
        }
        
        setLoading(false);
      } catch (err) {
        console.error("8. Error:", err);
        setError(err.message || "Failed to fetch events");
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  // 判断事件是否已结束
  const getEventStatus = (event) => {
    if (!event.end_date) return 'ongoing';
    const today = new Date();
    const endDate = new Date(event.end_date);
    return endDate < today ? 'ended' : 'ongoing';
  };

  const getActiveEvents = () => {
    if (activeTab === "ongoing") {
      return events.filter(event => getEventStatus(event) === 'ongoing');
    } else if (activeTab === "ended") {
      return events.filter(event => getEventStatus(event) === 'ended');
    }
    return events;
  };

  if (loading) {
    return (
      <div className={styles.wrapAllContainer}>
        <h2 className={styles.eventHeading}>Event</h2>
        <div className={styles.loading}>Loading events...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.wrapAllContainer}>
        <h2 className={styles.eventHeading}>Event</h2>
        <div className={styles.error}>
          <p>Error: {error}</p>
          <p style={{ fontSize: '12px', color: '#999' }}>
            Please check console for more details (F12)
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.wrapAllContainer}>
      <h2 className={styles.eventHeading}>Event</h2>
      <div className={styles.eventsList}>
        <div className={styles.filter}>
          <button
            className={`${styles.filterBtn} ${
              activeTab === "ongoing" ? styles.filterBtnActive : ""
            }`}
            onClick={() => setActiveTab("ongoing")}
          >
            Ongoing Events ({events.filter(e => getEventStatus(e) === 'ongoing').length})
          </button>
          <button
            className={`${styles.filterBtn} ${
              activeTab === "ended" ? styles.filterBtnActive : ""
            }`}
            onClick={() => setActiveTab("ended")}
          >
            Ended Events ({events.filter(e => getEventStatus(e) === 'ended').length})
          </button>
        </div>

        <div className={styles.eventCards}>
          {getActiveEvents().length > 0 ? (
            getActiveEvents().map((event) => (
              <Link
                to={`/events/${event.id}`}
                key={event.id}
                className={styles.eventLink}
              >
                <div className={styles.eventCard}>
                  <div className={styles.eventCardContent}>
                    <div className={styles.eventImageContainer}>
                      <img
                        src={`${API_BASE_URL}/uploads/eventImages/${event.image}`}
                        alt={event.name}
                        className={styles.eventImage}
                        onError={(e) => {
                          e.target.src = 'https://via.placeholder.com/300x200?text=No+Image';
                        }}
                      />
                      {getEventStatus(event) === 'ended' && (
                        <div className={styles.eventOverlay}>
                          <span className={styles.eventEndText}>Event End</span>
                        </div>
                      )}
                    </div>
                    <div className={styles.eventDetails}>
                      <h2>{event.name}</h2>
                      <p>{event.event_period}</p>
                    </div>
                  </div>
                </div>
              </Link>
            ))
          ) : (
            <p>No events available at this moment.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventSection;